import { Cascader, Form, Space, TreeSelect } from 'antd';
import React, { useEffect, useState } from "react";

import { apiCall } from "../../utils/Api";

export default function BisacSelector(props) {

  const {
    value,
    size = "middle",
    setValue = () => { },
    strToArr,
    multiple = true
  } = props;

  const [loading, setLoading] = useState(true);
  const [results, setResults] = useState([]);


  const values_array = strToArr(value);
  const [vals, setVals] = useState(
    {
      one: values_array[0] || "",
      two: values_array[1] || "",
      three: values_array[2] || "",
    }
  );


  useEffect(() => {
    const values_array = strToArr(value);

    setVals(
      {
        one: values_array[0] || "",
        two: values_array[1] || "",
        three: values_array[2] || "",
      }
    )

  }, [value])


  useEffect(() => {
    let str = Object.values(vals).filter(item => item !== "").join(",");
    if (str !== value) {
      setValue(str);
    }

  }, [vals])

  const markNonBooks = (_arr) => {

    return _arr.map(item => {
      if (!item.hasOwnProperty("id")) {
        return { ...item, "label": item.label + " (can't select)", "selectable": false, "children": markNonBooks(item.children) }
      }
      if (item.hasOwnProperty("id") && item.id.substr(0, 1) === "_") {
        return { ...item, "label": item.label + " (nonbook)", "selectable": true, "children": markNonBooks(item.children) }
      } else {
        return { ...item, "selectable": true }
      }
    })
  }

  const getBisacs = () => {
    apiCall("title/getBisacs", {}, (_status, _result) => {
      if (_status) {
        setResults(markNonBooks(_result));
        setLoading(false);
      }
    })
  }

  useEffect(getBisacs, []);

  const getOptions = (_results) => {
    return _results.map((item, index) => {
      return {
        value: item.id || item.label,
        key: item.id || item.label,
        name: item.label,
        title: (<div>{item.label} <small> - <em>({item.id})</em></small></div>),
        selectable: item.selectable,
        children: getOptions(item.children)
      }
    })
  }

  


  const getFullPath = (value, nodes, path = []) => {
    for (const node of nodes) {
      const current = [...path, node.name];

      if (node.value === value) return current;

      if (node.children) {
        const found = getFullPath(value, node.children, current);
        if (found) return found;
      }
    }

    return null;
  };


  const drawPath = (_val) => {
    if (!options?.length || !_val) {
      return (<></>)
    }
    let arr = getFullPath(_val, options);

    return (
      <Space split={<div style={{ "opacity": "0.5" }}>&gt;</div>}>
        {arr.map((item) => {
          return (<span style={{ "opacity": "0.8" }}>{item}</span>)
        })}
        <em style={{ "opacity": "0.8" }}>({_val})</em>
      </Space>
    )


  }

  const options = getOptions(results);

  const drawFields = () => {


    return (
      <>

        <label><small>Bisac 1:</small></label>
        <TreeSelect allowClear showCheckedStrategy={TreeSelect.SHOW_ALL} size={size} style={{ "width": "100%", "fontSize": (size === "small") ? "12px" : "14px" }} loading={loading} onChange={(e) => setVals({ ...vals, "one": e })} value={vals?.one} showSearch placeholder={(loading) ? "Loading..." : "Select Bisac"} treeData={options} />
        <small>{drawPath(vals?.one)}</small>
        <br /><br />
        <label><small>Bisac 2</small></label>
        <TreeSelect allowClear size={size} style={{ "width": "100%", "fontSize": (size === "small") ? "12px" : "14px" }} loading={loading} onChange={(e) => setVals({ ...vals, "two": e })} value={vals?.two} showSearch placeholder={(loading) ? "Loading..." : "Select Bisac"} treeData={options} />
        <small>{drawPath(vals?.two)}</small>
        <br /><br />

        <label><small>Bisac 3</small></label>
        <TreeSelect allowClear size={size} style={{ "width": "100%", "fontSize": (size === "small") ? "12px" : "14px" }} loading={loading} onChange={(e) => setVals({ ...vals, "three": e })} value={vals?.three} showSearch placeholder={(loading) ? "Loading..." : "Select Bisac"} treeData={options} />
        <small>{drawPath(vals?.three)}</small>
      </>
    )
  }


  return drawFields();

  // return (
  //   <>

  //     <pre>{JSON.stringify(vals, null, 2)}</pre>
  //     <TreeSelect size={size} style={{ "width": "100%", "fontSize": (size === "small") ? "12px" : "14px" }} multiple={multiple} loading={loading} onChange={(e) => setValue(e)} value={(value) ? strToArr(value) : undefined} showSearch placeholder={(loading) ? "Loading..." : "Select Bisac"} treeData={getOptions(results)} />
  //   </>
  // );
}